import {Component, OnInit}	from '@angular/core';
import {ContentRow}		from './content-row';
import {ContentService}		from './content.service';
import {Input} from "@angular/core";

@Component({
    selector: 'requirements-table',
    //directives: [ContentListComponent],
    //<div class="error" *ngIf="errorMessage">{{errorMessage}}</div>
    //template: `
		
	//`
    templateUrl: './requirements-table.component.template.html',
	styleUrls: ['../assets/css/req.css']
})
export class RequirementsTableComponent implements OnInit {

    constructor(private _contentService: ContentService) { }

    errorMessage: string;

    contentRows: ContentRow[];

    ngOnInit() {
        debugger;
        this.getContentNodes();
    }

    getContentNodes() {
        this._contentService.getContentNodes(Number(this.getUrlVars()['catId']))
                .subscribe(
                contentRows => {
                    this.contentRows = [];
                    contentRows.forEach((row, ix, rows) => {
                        this.contentRows.push(new ContentRow (
                            row.REQUIREMENT_SUBJECT_DESC,
                            row.REQUIREMENT_NUMBER,
                            row.REQUIREMENT_DESC,
                            row.REQUIREMENT_SOURCE_DESC,
                            row.REQUIREMENT_REMARKS
                        ));
                    });
                },
                error => this.errorMessage = <any>error
                );

    }

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }


}


@Component({
    selector: 'reqCategoryText',
    template: `
		{{this.categoryText}}
	`
    //templateUrl: './requirements-table.component.template.html',
	//styleUrls: ['../assets/css/req.css']
})
export class ReqCategoryTextComponent implements OnInit {

    constructor(/*private _requirementsTable: RequirementsTableComponent*/) { }

    public categoryText: string;

    ngOnInit() {
        debugger;
        this.categoryText = decodeURIComponent(this./*_requirementsTable.*/getUrlVars()['catTxt']||'');
    }

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }


}

@Component({
    selector: 'currDate',
    template: `
		{{this.currDate | date: 'dd.M.yyyy'}}
	`
})
export class currDateComponent  {

    constructor() { }

    public currDate: number = Date.now();

}







// WEBPACK FOOTER //
// ./src/app/requirements-table.component.ts